import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { AD_UNIT_REFRESHER_FRAGMENT } from 'features/inventory/ad-unit/api/fragments/adUnitRefresher'
import { AD_UNIT_UNFILLED_RECOVERY_FRAGMENT } from 'features/inventory/ad-unit/api/fragments/adUnitUnfilledRecovery'
import { AD_UNIT_VIEWABILITY_TOOLS_FRAGMENT } from 'features/inventory/ad-unit/api/fragments/adUnitViewabilityTools'
import { Ability } from 'providers/casl/types/ability'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { MEDIA_TYPES_FOR_FORM_FRAGMENT } from '../../ad-unit/forms/GeneralForm/hooks/useGetAdUnit/api/fragments/mediaTypes'
import { AdUnitDTO } from '../types/adUnitDTO'
import { DOMAIN_FRAGMENT } from './domain'
import { PAGE_FOR_AD_UNIT_TRANSFER_LIST_FRAGMENT } from './pageForAdUnitTransferList'

type Props = {
  ability: Ability
}

export const AD_UNIT_FRAGMENT = ({ ability }: Props): TypedDocumentNode<AdUnitDTO> => gql`
  ${AD_UNIT_UNFILLED_RECOVERY_FRAGMENT}
  ${AD_UNIT_VIEWABILITY_TOOLS_FRAGMENT}
  ${ALERT_FRAGMENT}
  ${DOMAIN_FRAGMENT({ ability })}
  ${MEDIA_TYPES_FOR_FORM_FRAGMENT}
  ${PAGE_FOR_AD_UNIT_TRANSFER_LIST_FRAGMENT}
  ${AD_UNIT_REFRESHER_FRAGMENT}

  fragment AdUnitFragment on AdUnit {
    ${permitFields<AdUnitDTO>({
      adUnitId: ability.can('read', 'AdUnitField-rawId'),
      ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
    })}

    adUnitAmazon {
      id
    }
    adUnitAmazonEnabled
    adUnitUnfilledRecovery {
      ...AdUnitUnfilledRecoveryFragment
    }
    adUnitRefresher {
      ...AdUnitRefresherFragment
    }
    adUnitViewabilityTool {
      ...AdUnitViewabilityToolsFragment
    }
    createdAt
    divId
    domain {
      ...DomainFragment
    }
    fieldAlerts {
      ...AlertFragment
    }
    id
    mediaTypes {
      ...MediaTypesFragment
    }
    name
    outOfPage
    outOfPageType
    pages {
      ...PageForAdUnitTransferList
    }
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
